import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function ActiveLoanReport() {
  return <ReportForm reportAPI={ ReportAPI.ACTIVE_LOAN } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/ActiveLoanReport.js